import SignInRequest from '../entities/SignInRequest'
import SignInResponse from '../entities/SignInResponse'
import { IAuthRepository } from '../repositories/IAuthRepository'

export interface ISignIn {
  execute(params: SignInRequest): Promise<SignInResponse>
}

export default class SignInImpl implements ISignIn {
  constructor(private readonly authRepository: IAuthRepository) {}
  public async execute(params: SignInRequest): Promise<SignInResponse> {
    const response = await this.authRepository.signIn(params)
    return response
  }
}
